var HttpUtils = require('../../util/http_utils');
var Logger = require('../../util/logger_utils');
var DomUtils = require('../../util/dom_utils');

import LanguageManager from '../language_manager/language_manager';

var config = require('../../config');

var RatingScreen = {};

const windowConfig = "toolbar=0,status=0,width=700,height=300,scrollbars=NO";

/**
 *
 * @param sessionToken
 * @param globalUserId
 * @param programId
 * @param {Object} options
 * @param {Boolean} [options.half=false] only use half of the player (left)
 */
RatingScreen.show = function(sessionToken, globalUserId, programId, options) {
    options = options || {};

    getRating(sessionToken, globalUserId, programId, function(success, value) {
        if (success) {
            var rating = value;
            var html = require('./rating_screen.hbs')({
                rateThis: LanguageManager.get('rate_this'),
                share: LanguageManager.get('share')
            });
            var module = DomUtils.createElement('div', {
                attributes: {'class': 'player-modal player-modal--end ' + (options.half ? 'is-series' : '')},
                innerHtml: html
            });

            // var module = DomUtils.createElementFromString();
            DomUtils.waitForElement('class', 'bitdash-ctrl-w', function(success, element) {
                if (success) {
                    element.appendChild(module);

                    rating ?
                        setStarActive(document.querySelector('input[value="' + rating + '"]')) :
                        setStarActive(document.querySelector('input[value="0.0"]'));

                    document.getElementsByClassName('end-rate')[0].addEventListener('click', function(event) {
                        var target = event.target;
                        if (target.tagName === 'LABEL') onStarClick(sessionToken, globalUserId, programId, document.getElementById(target.getAttribute('for')));
                        else if (target.tagName == 'INPUT') onStarClick(sessionToken, globalUserId, programId, event.target);
                        else Logger.warn('Event ignored. Could not find rating');
                    });
                } else {
                    Logger.error('Could not bind ratingscreen.', element);
                }
            });
        }

        // Todo: move this code to a specific function
        var fblink = document.getElementById('ff');
        fblink.onclick = function() {
            _shareOnFacebook(window.location.href, options.title);
        };

        var ttlink = document.getElementById('tt');
        ttlink.onclick = function() {
            _shareOnTwitter({title: options.title, url: window.location.href})
        };

        var iilink = document.getElementById('ee');
        iilink.onclick = function() {
            _shareOnMail(window.location.href, options.title)
        };
    });
};

RatingScreen.clean = function() {
    DomUtils.destroyElementByType('class', 'player-modal--end');
};

function onStarClick(sessionToken, globalUserId, programId, inputElem) {
    var rating = inputElem.value;
    setStarActive(inputElem);
    rateContent(sessionToken, globalUserId, programId, rating, function(success, data) {
        if (!success) {
            Logger.error('Failed to send rating: ', data);
        }
    });
}

function setStarActive(inputElem) {
    inputElem.checked = 'checked';
}

function rateContent(sessionToken, globalUserId, programId, rating, callback) {
    HttpUtils.post({
        uri: config.esbUrl + 'rating/' + globalUserId,
        body: {
            userId: globalUserId,
            aboutId: programId,
            value: parseInt(rating)
        },
        headers: {
            'Authorization': 'Bearer ' + sessionToken,
            'client-type': 'website',
            'xtype': 'portal'
        }
    },
        function onReply(success, data) {
            if (success) callback(true);
            else callback(false, data);
        }
    );
}

function getRating(sessionToken, globalUserId, programId, callback) {
    HttpUtils.get({
        uri: config.esbUrl + 'rating/?globalUserId=' + globalUserId + '&programID=' + programId,
        headers: {
            'Authorization': 'Bearer ' + sessionToken,
            'client-type': 'website',
            'xtype': 'portal'
        }
    }, function(success, body) {
        if (success && body) {
            body = JSON.parse(body);
            var rating = body && body[0] ? body[0] : false;
            if (rating && rating.value) {
                callback(true, rating.value);
            } else {
                callback(true, 0); // no rating
            }
        } else {
            callback(false, new Error('HTTP request failed.'));
        }
    });
};

function _shareOnFacebook (url, title, urlIsEncoded) {
    if(!urlIsEncoded) {
        url = encodeURIComponent(url);
    }
    var facebookSharerUrl = "http://www.facebook.com/sharer.php?u=",
        shareTitle = title;

    window.open(facebookSharerUrl + url , shareTitle , windowConfig);
};

function _shareOnTwitter (config, urlIsEncoded) {
    let twitterSharerUrl = "https://twitter.com/intent/tweet?source=webclient&text=";

    if(config){
        let viaStarzPlay = "&via=StarzPlayArabia";
        if(config.title && config.url) {
            let title = config.title.trim();
            let message =  LanguageManager.get('social_media_share.imwatching') + " " + title + " " + config.url;
            message = message.replace(/\s{2,}/g, ' ');
            if(!urlIsEncoded) {
                message = encodeURIComponent(message);
            }
            window.open(twitterSharerUrl + message + viaStarzPlay, title, windowConfig);

        } else if(config.tweet){
            tweet = config.tweet.replace(/\s{2,}/g, ' ');
            if(!urlIsEncoded) {
                tweet = encodeURIComponent(tweet);
            }
            window.open(twitterSharerUrl + tweet , title , windowConfig);
        }
    }
};

function _shareOnMail (url, title) {
    title = title.trim();
    var href = 'mailto:?subject=' + LanguageManager.get('social_media_share.imwatching') + title + LanguageManager.get('social_media_share.instarz') + ' &body=' + url;
    //$("#emaillink").remove();

    //$('body').append('<a href="'+href+'" id="emaillink" target="_blank">'+dict.imwatching + title + dict.instarz +'</a>');

    //$("#emaillink").simulate("click");

    var win = window.open(href,'emailWindow');
    setTimeout(function() { win.close() }, 500);
}

module.exports = RatingScreen;



// WEBPACK FOOTER //
// ./src/modules/rating_screen/rating_screen.js